import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import { Icon } from 'components/icons'

const iconCell = (props) => {
  return class IconCell extends GridCell {
    render () {
      const text = this.props.dataItem[this.props.field]
      return (
        <td>
          <Icon name={props.icon} />&nbsp;&nbsp;{text}
        </td>
      )
    }
  }
}
export {
  iconCell
}